module.exports = __webpack_public_path__ + "media/gem-found-blue.24d81a73.mp4";